export default "/images/HDAW_STEP_3.png";